import React from 'react';
import { Form, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

import { ACCOUNT_DATA_UPDATED_EVENT } from '../actions/account';
import {
  goBackToMainAccount,
  loginToMasterAccount,
  logoutRequest,
} from '../actions/auth';
import bp_banner from '../assets/bp_banner_large.png';
import { authorizedAccountMatchesSearch } from '../utils/authorizedAccountSearch';
// Tell webpack this JS file uses this image
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

class MainNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      account_data: {},
      authorized_accounts: [],
      authorized_accounts_search_text: '',
      registerScreen: false,
      accountDataVersion: 0,
    };
  }
  // Todo: Find faster way to get role
  componentDidMount() {
    this.handleAccountDataUpdated = () =>
      this.setState((s) => ({ accountDataVersion: s.accountDataVersion + 1 }));
    window.addEventListener(
      ACCOUNT_DATA_UPDATED_EVENT,
      this.handleAccountDataUpdated,
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      ACCOUNT_DATA_UPDATED_EVENT,
      this.handleAccountDataUpdated,
    );
  }

  handleLogout = () => {
    logoutRequest(this.logoutSuccess, this.logoutFail);
  };
  logoutSuccess = () => {
    this.props.history.push('/FindMoorings');
  };
  logoutFail = (error) => {
    this.props.history.push('/FindMoorings');
  };

  loginToMasterAccountPressed = (account) => {
    if (account.email === localStorage.getItem('email')) return;
    loginToMasterAccount(
      account.account_id,
      (response) => {},
      (error) => {},
    );
  };

  changeBackPressed = () => {
    goBackToMainAccount();
  };

  safeParseJson(str, fallback) {
    if (!str) return fallback;
    try {
      return JSON.parse(str) ?? fallback;
    } catch {
      return fallback;
    }
  }

  render() {
    const { t } = this.props;
    const authenticated = localStorage.getItem('AuthToken');
    const email = localStorage.getItem('email');
    const originalEmail = localStorage.getItem('originalEmail');
    const account_data = this.safeParseJson(
      localStorage.getItem('AccountData'),
      {},
    );

    const authorized_accounts_json = localStorage.getItem('AuthorizedAccounts');
    var authorized_accounts = this.safeParseJson(authorized_accounts_json, []);
    if (!Array.isArray(authorized_accounts)) authorized_accounts = [];
    const authorized_accounts_searchable = authorized_accounts.length > 3;
    const searchQuery = this.state.authorized_accounts_search_text
      .trim()
      .toLowerCase();
    if (searchQuery) {
      authorized_accounts = authorized_accounts.filter((authorized_account) =>
        authorizedAccountMatchesSearch(authorized_account, searchQuery),
      );
    }

    // const authorized_accounts = []
    // const management = this.state.account_data && this.state.account_data.role == "management";
    const role = localStorage.getItem('role');
    const management = role == 'management'; //TODO: check if account is management account
    const marina_account = role == 'marina';
    const isFindMooringsRole = role == 'private' || role == 'guest';
    const showBadgeManagement =
      account_data.show_badge_management === 1 ||
      account_data.show_badge_management === '1' ||
      account_data.show_badge_management === true;

    const register_screen = window.location.href.includes('register');

    const defaultLandingRoute = authenticated
      ? isFindMooringsRole
        ? '/FindMoorings'
        : '/home'
      : '/FindMoorings';

    return (
      <Navbar
        id='navbar'
        bg='light'
        expand='lg'
        sticky='top'
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 10,
          paddingTop: 10,
        }}>
        <Nav.Link href={defaultLandingRoute}>
          <Navbar.Brand id='nav_brand'>
            <img src={bp_banner} alt='Logo' />
            {process.env.REACT_APP_DEPLOYMENT_ENV == 'dev' && (
              <div
                style={{
                  color: 'red',
                  position: 'absolute',
                  marginLeft: 60,
                  marginTop: 40,
                }}>
                Dev
              </div>
            )}
          </Navbar.Brand>
        </Nav.Link>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='mr-auto'>
            {authenticated && (
              <Nav.Link id='nav_link_bookings' href='/Bookings'>
                {t('Navbar.reservations')}
              </Nav.Link>
            )}
            {authenticated && (
              <Nav.Link id='nav_link_moorings' href='/MooringTable'>
                {t('Navbar.moorings')}
              </Nav.Link>
            )}
            {authenticated &&
              account_data.rights &&
              account_data.rights.show_contact_tab && (
                <Nav.Link id='nav_link_contacts' href='/ContactTable'>
                  {t('Navbar.contacts')}
                </Nav.Link>
              )}
            {authenticated && management && (
              <Nav.Link
                id='nav_link_waiting_contacts'
                href='/WaitingContactsTable'>
                {t('Navbar.waitingList')}
              </Nav.Link>
            )}
            {authenticated && management && showBadgeManagement && (
              <Nav.Link id='nav_link_badges' href='/BadgeTable'>
                {t('Navbar.badges', 'Badges')}
              </Nav.Link>
            )}
            {authenticated && (
              <Nav.Link id='nav_link_account' href='/account'>
                {t('Navbar.account')}
              </Nav.Link>
            )}
            {!authenticated && (
              <Nav.Link id='nav_link_register' href='/register'>
                {t('Navbar.register')}
              </Nav.Link>
            )}
            {!authenticated && !register_screen && (
              <Nav.Link id='nav_link_login' href='/login'>
                {t('Navbar.login')}
              </Nav.Link>
            )}
          </Nav>
          {/* <Form inline>

            <Button variant="outline-success">Search</Button>
          </Form> */}
        </Navbar.Collapse>
        {/* {role} */}

        <Navbar.Collapse className='justify-content-end'>
          {authenticated && (
            <NavDropdown
              align='end'
              id='nav-dropdown-signed-in-as'
              title={`${email}`}>
              <NavDropdown.Item onClick={this.changeBackPressed}>
                {originalEmail}
              </NavDropdown.Item>
              <NavDropdown.Divider />
              {authorized_accounts_searchable && (
                <div>
                  <Form.Control
                    style={{ margin: 'auto', width: '95%' }}
                    value={this.state.authorized_accounts_search_text}
                    onChange={(e) =>
                      this.setState({
                        authorized_accounts_search_text: e.target.value,
                      })
                    }
                    type='search'
                    placeholder='Search'
                    className='me-2'
                    aria-label='Search'
                  />
                  <NavDropdown.Divider />
                </div>
              )}
              <div style={{ maxHeight: 500, overflowY: 'scroll' }}>
                {authorized_accounts.map((authorized_account) => (
                  <div key={authorized_account.account_id}>
                    <NavDropdown.Item
                      onClick={() =>
                        this.loginToMasterAccountPressed(authorized_account)
                      }>
                      {authorized_account.email}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                  </div>
                ))}
              </div>

              <NavDropdown.Item id='nav_logout' onClick={this.handleLogout}>
                {t('Navbar.logout')}
              </NavDropdown.Item>
            </NavDropdown>
          )}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default withTranslation()(withRouter(MainNavbar));
